<template>
  <div
    :style="`width:${dispW}px; height:${dispH}px;position:relative;left:0px;top:0px;overflow:hidden;`"
    v-finger:longTap="showSettings"
    @click.right="showSettings"
  >
    <img :src="imgUrl" :style="imgStyle" alt />
    <canvas
      v-finger:touchStart="start"
      v-finger:touchMove="move"
      v-finger:touchEnd="end"
      @mousedown.prevent="start"
      @mousemove.prevent="move"
      @mouseup.prevent="end"
      :id="`mapCanvas_${indexInForm}`"
      :style="canvasStyle"
    ></canvas>
    <MapDrawSettings
      :parentForm="parentForm"
      :indexInForm="indexInForm"
      :mapStyle="mapStyle"
      :isZernike="isZernike"
      :isVisible.sync="isSettingsVisibleBoolean"
      :isDiff="isDiff"
    />
    <el-button
      class="btn-oprator border-normal btn-elev-settings"
      @click="showElevSettings = true"
      v-show="mapIndexUI === mapStyles['ElevationF'] && !isDiff && parentForm !== 'zernike'"
    >
      <span class="iconfont icon-settings1" style="font-size: 35px"></span>
    </el-button>
    <ElevPropsSettings
      @updateMap="updateMapByData"
      :show.sync="showElevSettings"
      :parentForm="parentForm"
      :indexInForm="indexInForm"
      v-if="showElevSettings"
    ></ElevPropsSettings>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Map from "../js/Map.js";
import { MAPSTYLES, isDefined, isTrue } from "../shared/index";
import { TOPOGRAPHYEVENTS } from "../shared/events";
import MapDrawSettings from "../pages/dialog-forms/MapDrawSettings";
import ColorMapHelper from "../js/ColorMapHelper";
import ElevPropsSettings from "./ElevPropsSettings";
import { mapReference } from "../dataGetters/mapValues";
import mapDrawConfig from "../config/map-draw";
import fileSys from "../../fileoprators/fileSystem.js";
import EVENTS from "../../bus/index.js";
import { logStdout } from "../../shared/utils.js";
import { INVALID_1000 } from "../../shared/consts.js";

let maps = [undefined, undefined, undefined, undefined];
const fs = window.require("fs");
let isD = false;
export default {
  name: "Map",
  data() {
    return {
      imagePos: {},
      scale: 1,
      diameter: 12,
      imgUrl: "",
      isSettingsVisibleBoolean: false,
      loadImg: null,
      map: null,
      originMapCanvas: null,
      colorMapPtr: 0,
      diffMapPtr0: 0,
      diffMapPtr1: 0,
      url: "",
      showElevSettings: false,
      elevData: null,
      mapStyles: MAPSTYLES,
      updatedMapType: false,
      busLabel: "--",
      znkData: null,
      znkCntVal: -1,
      znkStep: 0,
      rgpData: null,
      hadDestory: false,
      fourierData: null,
      isMapDataOK: false,
      diffMapStatus0: false,
      diffMapStatus1: false
    };
  },
  props: {
    rgpDia: {
      type: Number,
      default: 6
    },
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    mapIndexUI: {
      type: Number,
      default: 1
    },
    parentForm: {
      type: String,
      default: ""
    },
    indexInForm: {
      type: Number,
      default: 0
    },
    isRGP: {
      type: Boolean,
      default: false
    },
    isDiff: {
      type: Boolean,
      default: false
    },
    isZernike: {
      type: Boolean,
      default: false
    },
    mapValues: {
      type: Object,
      default() {
        return {};
      }
    },
    casePath: {
      type: String,
      default: ""
    }
  },
  components: {
    MapDrawSettings,
    ElevPropsSettings
  },
  created() {
    // this.casePath = this.$store.state.topography.casePath
    this.initParams();
    if (this.isZernike) this.diameter = this.zernikeSet.diameter;
    this.initMapEvents();
  },
  mounted: function () {
    this.diameter = this.getMapDrawSettings().mapDrawSettings.ShowDiameter9mm ? 9 : this.diameter;

    this.updateUrl();
    this.$bus.$on(TOPOGRAPHYEVENTS.rgpDrawModeChanged, (mode) => {
      this.rgpDrawModeChanged(mode);
    });
    this.$bus.$on(TOPOGRAPHYEVENTS.rgpDataChanged, (data) => {
      this.rgpData = data;
      this.updateMap();
    });
    this.$bus.$on(TOPOGRAPHYEVENTS.znkDataChanged, (obj) => {
      this.znkData = obj.data;
      this.znkCntVal = obj.cntVal;
      this.znkStep = obj.step;
      this.UpdateDataPtr();
    });
    this.$bus.$on(TOPOGRAPHYEVENTS.fourierDataChanged, (data, index) => {
      if (index === this.indexInForm) {
        this.fourierData = data;
        this.updateMap();
      }
    });
    this.$bus.$on(TOPOGRAPHYEVENTS.medianModeChanged, () => {
      this.updateMap();
    });
    if (!this.isDiff && !this.isZernike && !this.isRGP) {
      this.updateMap();
    }
  },

  watch: {
    diameter: {
      handler(val) {
        if (isDefined(this.map)) {
          this.map.calcPixelsPerMM(val);
          this.map.updateMapDraw();
        }
        this.scale = 12.0 / val;
      },
      immediate: true
    },
    "zernikeSet.diameter": function (val) {
      if (this.isZernike) {
        this.diameter = val;
      }
      this.instantiateMap();
    },
    mapDrawSettings: {
      handler: function (val, oldVal) {
        if (!this.isZernike) {
          this.diameter = isTrue(this.getMapDrawSettings().mapDrawSettings.ShowDiameter9mm)
            ? 9
            : 12;
        }
        if (isDefined(this.map)) {
          this.map.setMapdrawSettings(this.getMapDrawSettings());
        }
        mapDrawConfig.saveSettings(val);
      },
      deep: true
    },
    dataShowSettings: {
      handler: function (val, oldVal) {
        if (isDefined(this.map)) {
          this.map.setMapdrawSettings(this.getMapDrawSettings());
        }
      },
      deep: true
    },
    mapIndexUI: function () {
      if (!this.isDiff) {
        this.updateMap();
      } else {
        this.updateDiffMap();
      }
    },
    // this.$store.state.topography.casePath
    casePath: function (curVal) {
      if (this.parentForm === "compare2records" && !this.isDiff) {
        if (curVal && curVal.length > 0) {
          let elevData =
            this.indexInForm === 0 ? global.elevParamsDiff0.data : global.elevParamsDiff1.data;
          this.elevData = elevData;
          this.updateMapByData(elevData);
          this.updateMap();
        }
      }
    }
  },
  computed: {
    // 字符串
    ...mapGetters([
      "mapDrawSettings",
      "dataShowSettings",
      "zernikeSet",
      "zernikeViewParams",
      "zernikeParams"
    ]),
    mapStyle: function () {
      return MAPSTYLES[this.mapIndexUI];
    },
    imgStyle: function () {
      let val = 50 / this.scale;
      let style = {
        position: "absolute",
        boxSizing: "border-box",
        border: this.isRGP ? "4px solid white" : "none",
        left: `${this.imagePos.left}px`,
        top: `${this.imagePos.top}px`,
        width: `${2 * this.imagePos.radius}px`,
        height: `${2 * this.imagePos.radius}px`,
        fontSize: "0px",
        lineHeight: "0px",
        transform: `scale(${this.scale})`,
        clipPath: `circle(${val}% at 50% 50%)`,
        borderRadius: "50%"
      };
      return style;
    },
    canvasStyle: function () {
      let style = {
        position: "absolute",
        fontSize: "0px",
        lineHeight: "0px",
        left: "0px",
        top: "0px",
        width: `${this.dispW}px`,
        height: ` ${this.dispH}px`
      };

      return style;
    }
  },
  methods: {
    ...mapActions({
      zernikViewParamsChanged: "topography/zernikViewParamsChanged"
    }),
    start(e) {
      maps.map((map) => {
        if (isDefined(map)) {
          map.emit(TOPOGRAPHYEVENTS.onDrawStart, e);
        }
      });
    },
    move(e) {
      maps.map((map) => {
        if (isDefined(map)) {
          map.emit(TOPOGRAPHYEVENTS.onDrawMove, e);
        }
      });
    },
    end(e) {
      maps.map((map) => {
        if (isDefined(map)) {
          map.emit(TOPOGRAPHYEVENTS.onDrawEnd, e);
        }
      });
    },
    showSettings(e) {
      this.isSettingsVisibleBoolean = true;
    },
    getMapDrawSettings() {
      // console.log(this.mapDrawSettings)
      // console.log(this.parentForm)
      // console.log(this.indexInForm)
      if (this.isRGP) {
        this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm][
          "shapes"
        ].ShowDiameter9mm = false;
        this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm][
          "shapes"
        ].ShowNinemmBorder = false;
      }
      return {
        mapDrawSettings:
          this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"],
        dataShowSettings: this.dataShowSettings
      };
    },
    pressMove(evt) {
      if (isDefined(this.map)) {
        this.map.emit("drawtick");
      }
    },
    rgpDrawModeChanged(mode) {
      if (isDefined(this.map)) {
        this.map.emit(TOPOGRAPHYEVENTS.rgpDrawModeChanged, mode);
      }
    },

    instantiateMap() {
      if (this.hadDestory) {
        return;
      }
      let _self = this;
      let dom = document.getElementById(`mapCanvas_${_self.indexInForm}`);
      let numericVals = mapReference.getNumVals(this.colorMapPtr);
      let casePath = this.$store.state.topography.casePath; // this.parentForm === 'compare2records' ? this.casePath : this.casePath
      let minMaxVals = mapReference.readMinMaxVals(casePath, this.mapStyle, isD);
      logStdout("instantiate map", dom);
      if (!isDefined(dom)) return;
      this.map = new Map(
        dom,
        this.diameter,
        {
          isRGP: _self.isRGP,
          isZernike: _self.isZernike,
          mapValues: this.mapValues.params,
          data: { numericVals, minMaxVals },
          maxPeak: this.zernikeViewParams.maxPeak,
          eyetype: this.mapValues.eyetype,
          colorMapPtr: this.colorMapPtr,
          originMapCanvas: this.originMapCanvas
        },
        this.mapDrawSettings[this.mapStyle],
        this.rgpDia,
        this.mapStyle
      );
      maps[this.indexInForm] = this.map;
      _self.imagePos = {
        left: this.map.mapCircle.left,
        top: this.map.mapCircle.top,
        radius: this.map.mapCircle.radius
      };
      this.map.drawCircleScale();
      _self.imgUrl = this.loadImg.src;
      _self.$bus.$emit(TOPOGRAPHYEVENTS.updateZernikeChart);
      _self.$bus.$emit(TOPOGRAPHYEVENTS.rgpDrawModeInitted, this.map.getRGPDrawMode());
      this.map.setMapdrawSettings(this.getMapDrawSettings());
      this.map.on(TOPOGRAPHYEVENTS.drawTickColorBar, (ev) => {
        this.drawTick(ev);
      });
      this.map.on(TOPOGRAPHYEVENTS.rgpRotate, (angle) => {
        this.$bus.$emit(TOPOGRAPHYEVENTS.rgpRotate, angle);
      });
      this.map.on(TOPOGRAPHYEVENTS.rgpOffsetChanged, (offset) => {
        this.$bus.$emit(TOPOGRAPHYEVENTS.rgpOffsetChanged, offset);
      });
      this.map.on(TOPOGRAPHYEVENTS.finishDrawTick, () => {
        this.finishDrawTick();
      });
      this.map.on("movable-center-pos", (centerpos) => {});
      this.$bus.$emit(EVENTS.hideGlobalWatting);
    },
    updateUrl: function () {
      this.loadImg = new Image();
      let mockUrl =
        process.env.NODE_ENV === "production"
          ? fileSys.getStaticImagePath("map.jpg")
          : "../static/img/map.jpg";
      this.loadImg.src = window.__ct__.debug ? mockUrl : this.url; // this.url
      if (!this.url) {
        this.instantiateMap(this.loadImg);
      } else {
        this.loadImg.onload = () => {
          this.instantiateMap(this.loadImg);
        };
      }
    },
    initParams() {
      let isCompareNormal = this.parentForm === "compare2records" && !this.isDiff;
      if (isCompareNormal) {
        this.busLabel = this.parentForm + "0";
        this.elevData =
          this.indexInForm === 0 ? global.elevParamsDiff0.data : global.elevParamsDiff1.data;
      } else {
        this.busLabel = this.parentForm + this.indexInForm;
        this.elevData = global.elevParams.data;
      }

      this.colorMapPtr = ColorMapHelper.initColorMap();
      // console.log('initptr---------', this.colorMapPtr, 'mapInForm' + this.indexInForm, this.parentForm)
    },
    initMapEvents() {
      this.$bus.$on(TOPOGRAPHYEVENTS.colorBarPropChanged + this.busLabel, (colorProp, isManual) => {
        this.onColorBarChanged(colorProp);
        if (isManual) {
          this.$bus.$emit(TOPOGRAPHYEVENTS.diffColorBarChanged, colorProp, this.isDiff);
        }
      });
      if (this.isDiff) {
        this.$bus.$on(TOPOGRAPHYEVENTS.diffMapChanged, (ptr, mapInForm, isBad) => {
          if (mapInForm === 0) {
            this.diffMapPtr0 = ptr;
            this.diffMapStatus0 = !isBad;
          } else if (mapInForm === 1) {
            this.diffMapPtr1 = ptr;
            this.diffMapStatus1 = !isBad;
          } else {
            return;
          }
          this.updateDiffMap();
        });
      }
    },
    onColorBarChanged(colorProp) {
      if (this.colorMapPtr === 0 || !this.updatedMapType || !this.isMapDataOK) {
        return;
      }

      isD = colorProp.unit === "D";
      let result;
      if (this.isDiff) {
        result = ColorMapHelper.updateDataDiff(
          this.colorMapPtr,
          this.diffMapPtr0,
          this.diffMapPtr1
        );
        let mapType = ColorMapHelper.getMapTypeByPtr(this.diffMapPtr0);
        if (mapType !== this.mapIndexUI || !result) {
          this.url = "";
          this.imgUrl = "";
          this.updateUrl();
          return;
        }
      }

      result = ColorMapHelper.updateColorBarProp(this.colorMapPtr, colorProp);
      if (result !== true) {
        this.url = "";
        this.imgUrl = "";
        this.updateUrl();
        return;
      }
      let mapresult = ColorMapHelper.getMapBmpUrl(this.colorMapPtr);
      if (isDefined(mapresult)) {
        this.url = mapresult.url;
        this.originMapCanvas = mapresult.canvas;
      } else {
        this.url = "";
        this.imgUrl = "";
        this.originMapCanvas = null;
      }
      this.updateUrl();
      let csSiArray = ColorMapHelper.getCsSiArray(this.colorMapPtr, colorProp.num);
      this.$bus.$emit(
        TOPOGRAPHYEVENTS.refreshScaleColor + this.busLabel,
        csSiArray.csArray,
        csSiArray.siArray
      );
      // 刷新差值地形图
      if (this.parentForm === "compare2records" && !this.isDiff) {
        this.$bus.$emit(TOPOGRAPHYEVENTS.diffMapChanged, this.colorMapPtr, this.indexInForm);
      }
    },
    updateDiffMap() {
      if (this.diffMapPtr0 === 0 || this.diffMapPtr1 === 0) {
        return;
      }
      if (!this.diffMapStatus0 || !this.diffMapStatus1) {
        this.url = "";
        this.imgUrl = "";
        ColorMapHelper.SetDataValid(this.colorMapPtr);
        this.updateUrl();
        return;
      }
      if (
        ColorMapHelper.getCSByPtr(this.diffMapPtr0) !==
          ColorMapHelper.getCSByPtr(this.diffMapPtr1) ||
        ColorMapHelper.getIsDByPtr(this.diffMapPtr0) !==
          ColorMapHelper.getIsDByPtr(this.diffMapPtr1) ||
        ColorMapHelper.getMapTypeByPtr(this.diffMapPtr0) !==
          ColorMapHelper.getMapTypeByPtr(this.diffMapPtr1)
      ) {
        this.updatedMapType = true;
        this.url = "";
        this.imgUrl = "";
        this.updateUrl();
        return;
      }

      if (!ColorMapHelper.updateMapProp(this.colorMapPtr, this.mapIndexUI, null)) {
        this.isMapDataOK = false;
        this.updatedMapType = true;
        this.url = "";
        this.imgUrl = "";
        // this.originMapCanvas = null
        // ColorMapHelper.freeColorMap(this.colorMapPtr)
        // this.colorMapPtr = ColorMapHelper.initColorMap()
        this.updateUrl();
        return;
      }
      this.isMapDataOK = true;
      this.updatedMapType = true;
      this.$bus.$emit(TOPOGRAPHYEVENTS.mapStyleChanged + this.busLabel, this.mapIndexUI);
    },
    updateMap() {
      let casePath = this.$store.state.topography.casePath; // this.casePath
      if (this.parentForm === "compare2records") {
        casePath = this.casePath;
      }
      if (
        !fs.existsSync(casePath) ||
        !ColorMapHelper.updateMapProp(this.colorMapPtr, this.mapIndexUI, casePath)
      ) {
        this.isMapDataOK = false;
        this.updatedMapType = true;
        this.url = "";
        this.imgUrl = "";
        // this.originMapCanvas = null
        // ColorMapHelper.freeColorMap(this.colorMapPtr)
        // this.colorMapPtr = ColorMapHelper.initColorMap()
        this.UpdateDataPtr();
        this.updateUrl();
        // 刷新差值地形图
        if (this.parentForm === "compare2records" && !this.isDiff) {
          // ColorMapHelper.freeColorMap(this.colorMapPtr)
          // this.colorMapPtr = 0
          this.$bus.$emit(
            TOPOGRAPHYEVENTS.diffMapChanged,
            this.colorMapPtr,
            this.indexInForm,
            true
          );
        }
        return;
      }
      this.isMapDataOK = true;
      this.updatedMapType = true;
      this.UpdateDataPtr();
      this.$bus.$emit(TOPOGRAPHYEVENTS.mapStyleChanged + this.busLabel, this.mapIndexUI);
    },
    UpdateDataPtr() {
      let data;

      if (this.parentForm === "zernike") {
        // this.updateZernike()
        data = this.znkData;
      } else if (this.mapIndexUI === MAPSTYLES["ElevationF"]) {
        data = this.elevData;
      } else if (this.mapIndexUI === MAPSTYLES["TearThickness"]) {
        data = this.rgpData;
      } else if (this.parentForm === "fourierAnalysis") {
        data = this.fourierData;
      }

      if (data) {
        ColorMapHelper.UpdateMapData(this.colorMapPtr, data);
        if (this.parentForm === "zernike") {
          this.$bus.$emit(
            TOPOGRAPHYEVENTS.zernikeColorBarChanged + this.busLabel,
            this.znkCntVal,
            this.znkStep
          );
        }
      } else if (
        this.mapIndexUI === MAPSTYLES["ElevationF"] &&
        this.parentForm === "compare2records" &&
        !this.isDiff
      ) {
        ColorMapHelper.UpdateMapData(this.colorMapPtr, data);
        this.isMapDataOK = false;
        this.$bus.$emit(TOPOGRAPHYEVENTS.diffMapChanged, this.colorMapPtr, this.indexInForm, true);
      }
    },
    updateMapByData(data) {
      if (this.isDiff) return;
      if (this.mapIndexUI === MAPSTYLES["ElevationF"]) {
        this.elevData = data;
        ColorMapHelper.UpdateMapData(this.colorMapPtr, data);
        this.$bus.$emit(TOPOGRAPHYEVENTS.mapStyleChanged + this.busLabel, this.mapIndexUI);
        if (!data) {
          // this.isMapDataOK = false
          this.$bus.$emit(
            TOPOGRAPHYEVENTS.diffMapChanged,
            this.colorMapPtr,
            this.indexInForm,
            true
          );
        }
      }
    },
    drawTick(ev) {
      let result = ColorMapHelper.getPixelIndexAndValue(this.colorMapPtr, ev.x, ev.y);
      if (result.result !== 0) {
        return;
      }
      this.$bus.$emit(
        TOPOGRAPHYEVENTS.refreshFocus + this.busLabel,
        this.parentForm + this.indexInForm,
        result.index
      );
      this.hadDraw = true;
    },
    finishDrawTick() {
      if (this.hadDraw) {
        this.$bus.$emit(
          TOPOGRAPHYEVENTS.refreshFocus + this.busLabel,
          this.parentForm + this.indexInForm,
          0,
          false
        );
      }
    }
  },
  destroyed() {
    this.hadDestory = true;
    this.$bus.$off(TOPOGRAPHYEVENTS.rgpDrawModeChanged);
    this.$bus.$off(TOPOGRAPHYEVENTS.colorBarPropChanged + this.busLabel);
    this.$bus.$off(TOPOGRAPHYEVENTS.rgpDataChanged);
    this.$bus.$off(TOPOGRAPHYEVENTS.znkDataChanged);
    this.$bus.$off(TOPOGRAPHYEVENTS.fourierDataChanged);
    this.$bus.$off(TOPOGRAPHYEVENTS.medianModeChanged);
    if (this.isDiff) {
      this.$bus.$off(TOPOGRAPHYEVENTS.diffMapChanged);
    }
    // console.log('freeptr---------', this.colorMapPtr, 'mapInForm' + this.indexInForm, this.parentForm)
    ColorMapHelper.freeColorMap(this.colorMapPtr);
    this.colorMapPtr = 0;
    maps = [null, null, null, null];
  }
};
</script>
<style lang="less" scoped>
img {
  clip-path: circle(50% at 50% 50%);
  user-select: none;
}
.btn-oprator:hover {
  .label {
    color: @btn-hover-color;
  }
}
.btn-oprator {
  height: @header-fs+25px;
}
.border-normal :hover {
  span {
    color: @btn-hover-color;
  }
}
.btn-elev-settings {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px 15px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/Map.vue